import type { Locale } from '../../i18n';

const MINUS = '−';

function signed(formatted: string): string {
  return formatted.replace(/^-/, MINUS);
}

export function score(value: number, locale: Locale): string {
  const formatted = new Intl.NumberFormat(locale, {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
    signDisplay: 'exceptZero',
  }).format(value);
  return signed(formatted);
}

/** A whole signed count, such as praise minus criticism. */
export function net(value: number, locale: Locale): string {
  return signed(
    new Intl.NumberFormat(locale, { maximumFractionDigits: 0, signDisplay: 'exceptZero' }).format(
      value,
    ),
  );
}

export function share(value: number, locale: Locale): string {
  return new Intl.NumberFormat(locale, { style: 'percent', maximumFractionDigits: 0 })
    .format(value)
    .replace(/\s/g, '');
}

export function count(value: number, locale: Locale): string {
  return new Intl.NumberFormat(locale, { maximumFractionDigits: 0 }).format(value);
}

// Bracket/semicolon notation reads as statistics jargon to a communications
// reader; a spelled-out range does not, so the connector word carries the
// only locale-specific part of this function.
const RANGE_CONNECTOR: Record<Locale, string> = { 'pt-BR': 'a', en: 'to' };

export function interval(low: number, high: number, locale: Locale): string {
  return `${score(low, locale)} ${RANGE_CONNECTOR[locale]} ${score(high, locale)}`;
}
